import React from "react"
import { connect, ConnectedProps } from "react-redux"
// import { HLog } from "src/core/helpers"
const mapStateToProps = state => ({
  headerTitle: state.app.headerTitle,
})

const mapDispatchToProps = {
  // logout,
  // toggleSideNav,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {}

const Header = (props: Props) => {
  // const { logout, toggleSideNav } = props
  const { headerTitle } = props
  return <h5 className="title-page mb-0">{headerTitle}</h5>
}

// export default Header
export default connector(Header)
